import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./error.html";
import { WireI18n } from '~/modules/stores/i18nStore';
import { routerStore } from '~/modules/stores/routerStore';
import { images } from '~/modules/utilities/assetUtilities';
import { logger } from '~/modules/utilities/logger';
class ErrorPage extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * Automated Type Error Fix
    this.labels = null;
    this.imageUrl = images.errorBird;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.error.errorPage;
  }
  get errorCode() {
    const queryString = routerStore.getState().queryString;
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const code = params.get('code');
      if (code != null && code !== '') {
        return code;
      }
    }
    return 'UNKNOWN';
  }
  connectedCallback() {
    logger.error(`Landed on Error Page with error '${this.errorCode}'${document.referrer ? `, from referrer: '${document.referrer}'` : ''}`);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ErrorPage, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["labels", "imageUrl"]
});
const __lwc_component_class_internal = _registerComponent(ErrorPage, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;